import { Component, OnInit } from '@angular/core';
import { TaskService } from 'src/services/task.service';
import { AppService } from 'src/app/app.service';
import { DashboardService } from 'src/services/dashboard.service';
import * as moment from 'moment';

@Component({
  selector: 'app-monthly',
  templateUrl: './monthly.component.html',
  styleUrls: ['./monthly.component.css']
})
export class MonthlyComponent implements OnInit {
  public startDate = moment().startOf('month').format('MM/DD/YYYY');
  public endDate = moment().endOf('month').format('MM/DD/YYYY');
  public selectDate: any;
  public projectsList = [];
  public usersList = [];
  public year: any = moment().format('YYYY');

  constructor(
    private appService: AppService,
    private taskService: TaskService,
    private dashboardService: DashboardService
  ) { }

  ngOnInit() {
    this.appService.headerTitle.emit({
      data: "Monthly Report"
    });
    this.changeDate('today');
  }

  changeDate(data?: any) {
    let requestCall = false;
    let todayDate = moment().endOf('month').format('MM/DD/YYYY');//.subtract(1, 'months')
    if (data == 'prev') {
      this.startDate = moment(this.startDate).subtract(1, 'months').startOf('month').format('MM/DD/YYYY');
      this.endDate = moment(this.startDate).endOf('month').format('MM/DD/YYYY');
      requestCall = true;
    } else if (data == 'next' && todayDate != this.endDate) {
      this.startDate = moment(this.startDate).add(1, 'months').startOf('month').format('MM/DD/YYYY');
      this.endDate = moment(this.startDate).endOf('month').format('MM/DD/YYYY');
      requestCall = true;
    } else if (data == 'today') {
      this.startDate = moment().startOf('month').format('MM/DD/YYYY');//.subtract(1, 'months')
      this.endDate = moment(this.startDate).endOf('month').format('MM/DD/YYYY');
      requestCall = true;
    }

    if (requestCall) {
      $(".custom-loader").css("display", "table");
      $(".loader-response").css("display", "none");
      this.selectDate = moment(this.startDate).format('MMMM YYYY');
      this.getTasksByProjects(this.startDate, this.endDate);
      this.getTasksByUsers(this.startDate, this.endDate);
    }

    if (this.endDate == todayDate) {
      $("#nextBtn").css("cursor", "not-allowed");
    } else {
      $("#nextBtn").css("cursor", "pointer");
    }
  }

  getTasksByProjects(startDate, endDate) {
    this.dashboardService.getProjectsReport(startDate, endDate).subscribe(res => {
      if (res.status == "ok") {
        let data = res.data;
        if (data.length == 0) {
          // this.changeDate('prev');
        } else {
          this.projectsList = data;
          this.projectsList.sort((a, b) => { return b.totalHours - a.totalHours; });
        }
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  getTasksByUsers(startDate, endDate) {
    this.dashboardService.getUsersReport(startDate, endDate).subscribe(res => {
      if (res.status == "ok") {
        let data = res.data;
        if (data.length == 0) {
          // this.changeDate('prev');
        } else {
          this.usersList = data;
          this.usersList.sort((a, b) => { return b.totalHours - a.totalHours; });
        }
        $(".custom-loader").css("display", "none");
        $(".loader-response").css("display", "block");
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

}
